// console.log('<<<<<<<<<< Segment Track Loaded >>>>>>>>>>');
const segmentTrack = {
  findAndReturnCookieValue: (cookieName) => {
    const name = cookieName + '=';
    return document.cookie.split(';').find(c => c.trim().startsWith(name))?.substring(name.length);
  },
  commonProps: () => {
    let referrerPath = null;
    if (document.referrer && document.referrer !== "") {
      referrerPath = new URL(document.referrer).pathname;
    }
    
    const common_properties = {
      referrer: document.referrer,
      referrer_path: referrerPath,
      url: window.location.href,
      url_path: window.location.pathname
    }
    return common_properties;
  },
  collection: ({ collection, products }) => {
    analytics.track('Product List Viewed', {
      list_id: collection.id,
      category: collection.title,
      category_url: collection.url,
      products,
      ...segmentTrack.commonProps()
    });
  },
  product: ({ product }) => {
    analytics.track('Product Viewed', {
      available: product.available,
      compare_at_price: product.compare_at_price,
      compare_at_price_max: product.compare_at_price_max,
      compare_at_price_min: product.compare_at_price_min,
      compare_at_price_varies: product.compare_at_price_varies,
      content: product.content,
      created_at: product.created_at,
      description: product.description,
      featured_image: product.featured_image,
      handle: product.handle,
      id: product.id,
      images: product.images,
      media: product.media,
      options: product.options,
      price: product.price,
      price_max: product.price_max,
      price_min: product.price_min,
      price_varies: product.price_varies,
      published_at: product.published_at,
      tags: product.tags,
      title: product.title,
      type: product.type,
      variants: JSON.stringify(product.variants),
      vendor: product.vendor,
      ...segmentTrack.commonProps()
    })
  },
  productSelection: (selection) => {
    analytics.track('Product Selected', {
      ...selection,
      ...segmentTrack.commonProps()
    })
  },
  cart: ({ ...cart_items }) => {
    let cart_id = segmentTrack.findAndReturnCookieValue('cart');

    if(cart_items.action === 'add') {
      analytics.track('Product Added', {
        ...(cart_id && { cart_id: cart_id }),
        ...cart_items,
        ...segmentTrack.commonProps()
      })
    }

    if(cart_items.action === 'remove') {
      analytics.track('Product Removed', {
        ...(cart_id && { cart_id: cart_id }),
        ...cart_items,
        ...segmentTrack.commonProps()
      })
    }
  },
  checkout: ({ ...checkout_items }) => {
    analytics.track('Checkout Step Viewed', {
      ...checkout_items,
      ...segmentTrack.commonProps()
    });
  }
}
window.segmentTrack = segmentTrack
window.addEventListener('DOMContentLoaded', segmentTrack.init)